import Ahsap from '../../assets/img/OurReferences/Manufacturing/Ahsap.webp'
import AksoyAmbalaj from '../../assets/img/OurReferences/Manufacturing/AksoyAmbalaj.webp'
import Apa from '../../assets/img/OurReferences/Manufacturing/Apa.webp'
import ASM from '../../assets/img/OurReferences/Manufacturing/ASM.webp'
import Astes from '../../assets/img/OurReferences/Manufacturing/Astes.webp'
import AtesGroup from '../../assets/img/OurReferences/Manufacturing/Ates_Group.webp'
import AyancikAhsap from '../../assets/img/OurReferences/Manufacturing/AyancikAhsap.webp'
import Ayguler from '../../assets/img/OurReferences/Manufacturing/Ayguler.webp'
import Aypek from '../../assets/img/OurReferences/Manufacturing/Aypek.webp'
import Bakanlar from '../../assets/img/OurReferences/Manufacturing/Bakanlar.webp'
import Bayramoglu from '../../assets/img/OurReferences/Manufacturing/Bayramoglu.webp'
import Başyazıcı from '../../assets/img/OurReferences/Manufacturing/Başyazıcı.webp'
import Bester from '../../assets/img/OurReferences/Manufacturing/Bester.webp'
import Blokbims from '../../assets/img/OurReferences/Manufacturing/Blokbims.webp'
import Bomeks from '../../assets/img/OurReferences/Manufacturing/Bomeks.webp'
import Bozbeyoglu from '../../assets/img/OurReferences/Manufacturing/Bozbeyoglu.webp'
import CagKabara from '../../assets/img/OurReferences/Manufacturing/CagKabara.webp'
import Cagrifence from '../../assets/img/OurReferences/Manufacturing/Cagrifence.webp'
import Cemre from '../../assets/img/OurReferences/Manufacturing/Cemre.webp'
import DenizPlastik from '../../assets/img/OurReferences/Manufacturing/DenizPlastik.webp'
import DLBA from '../../assets/img/OurReferences/Manufacturing/DLBA.webp'
import EggValley from '../../assets/img/OurReferences/Manufacturing/EggValley.webp'
import Ekrem from '../../assets/img/OurReferences/Manufacturing/Ekrem.webp'
import Elmasan from '../../assets/img/OurReferences/Manufacturing/Elmasan.webp'
import ERPEN from '../../assets/img/OurReferences/Manufacturing/ERPEN.webp'
import Esenyum from '../../assets/img/OurReferences/Manufacturing/Esenyum.webp'
import Etcii from '../../assets/img/OurReferences/Manufacturing/Etcii.webp'
import Garanti from '../../assets/img/OurReferences/Manufacturing/Garanti.webp'
import Gencler from '../../assets/img/OurReferences/Manufacturing/Gencler.webp'
import Gocmenler from '../../assets/img/OurReferences/Manufacturing/Gocmenler.webp'
import Isiklar from '../../assets/img/OurReferences/Manufacturing/Isiklar.webp'
import Itimat from '../../assets/img/OurReferences/Manufacturing/Itimat.webp'
import Karabacak from '../../assets/img/OurReferences/Manufacturing/Karabacak.webp'
import Kavaklidere from '../../assets/img/OurReferences/Manufacturing/Kavaklidere.webp'
import Klepsan from '../../assets/img/OurReferences/Manufacturing/Klepsan.webp'
import Kutlusan from '../../assets/img/OurReferences/Manufacturing/kutlusan.webp'
import Liyafe from '../../assets/img/OurReferences/Manufacturing/Liyafe.webp'
import Maret from '../../assets/img/OurReferences/Manufacturing/Maret.webp'
import Merva from '../../assets/img/OurReferences/Manufacturing/Merva.webp'
import Metaksan from '../../assets/img/OurReferences/Manufacturing/Metaksan.webp'
import NadirEt from '../../assets/img/OurReferences/Manufacturing/NadirEt.webp'
import Namet from '../../assets/img/OurReferences/Manufacturing/Namet.webp'
import NovaElektik from '../../assets/img/OurReferences/Manufacturing/NovaElektrik.webp'
import Omkatas from '../../assets/img/OurReferences/Manufacturing/Omkatas.webp'
import Ozemek from '../../assets/img/OurReferences/Manufacturing/Ozemek.webp'
import Perge from '../../assets/img/OurReferences/Manufacturing/Perge.webp'
import Radsan from '../../assets/img/OurReferences/Manufacturing/Radsan.webp'
import Ramcelic from '../../assets/img/OurReferences/Manufacturing/Ramcelic.webp'
import RNV from '../../assets/img/OurReferences/Manufacturing/RNV.webp'
import SahTavuk from '../../assets/img/OurReferences/Manufacturing/sahTavuk.webp'
import Sanat from '../../assets/img/OurReferences/Manufacturing/Sanat.webp'
import Senyayla from '../../assets/img/OurReferences/Manufacturing/Senyayla.webp'
import Setas from '../../assets/img/OurReferences/Manufacturing/Setas.webp'
import SevgiCam from '../../assets/img/OurReferences/Manufacturing/SevgiCam.webp'
import Silivri from '../../assets/img/OurReferences/Manufacturing/Silivri.webp'
import SimiTeks from '../../assets/img/OurReferences/Manufacturing/SimiTeks.webp'
import SismanYumurta from '../../assets/img/OurReferences/Manufacturing/SismanYumurta.webp'
import SME from '../../assets/img/OurReferences/Manufacturing/SME.webp'
import Soprano from '../../assets/img/OurReferences/Manufacturing/Soprano.webp'
import Tekkeli from '../../assets/img/OurReferences/Manufacturing/Tekkeli.webp'
import Teksan from '../../assets/img/OurReferences/Manufacturing/Teksan.webp'
import Tugsan from '../../assets/img/OurReferences/Manufacturing/Tugsan.webp'
import Tunas from '../../assets/img/OurReferences/Manufacturing/Tunas.webp'
import Yasmin from '../../assets/img/OurReferences/Manufacturing/Yasmin.webp'
import s from '../Manufacturing/Manufacturing.module.css'

export const Manufacturing = () => {
	return (
		<div className={s.Manufacturing}>
			<div className={s.ManufacturingBG}>
				<h3>Manufacturing</h3>
			</div>
			<div className={s.Wrapper}>
				<div className='container'>
					<ul className={s.List}>
						<li className={s.Item}>
							<img width={320} height={150} src={Ahsap} alt='Ahsap' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Aypek} alt='Aypek' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Ayguler} alt='Ayguler' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={AksoyAmbalaj}
								alt='AksoyAmbalaj'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Apa} alt='Apa' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={AtesGroup} alt='AtesGroup' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Astes} alt='Astes' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={ASM} alt='ASM' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={AyancikAhsap}
								alt='AyancikAhsap'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Başyazıcı} alt='Başyazıcı' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Bozbeyoglu} alt='Bozbeyoglu' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Bayramoglu} alt='Bayramoglu' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Bakanlar} alt='Bakanlar' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Bomeks} alt='Bomeks' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Blokbims} alt='Blokbims' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Bester} alt='Bester' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={DenizPlastik}
								alt='DenizPlastik'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={DLBA} alt='DLBA' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Cagrifence} alt='Cagrifence' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Cemre} alt='Cemre' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={CagKabara} alt='CagKabara' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={EggValley} alt='EggValley' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={ERPEN} alt='ERPEN' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Ekrem} alt='Ekrem' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Etcii} alt='Etcii' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Esenyum} alt='Esenyum' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Karabacak} alt='Karabacak' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={Kavaklidere}
								alt='Kavaklidere'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Klepsan} alt='Klepsan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Kutlusan} alt='Kutlusan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Liyafe} alt='Liyafe' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={NovaElektik}
								alt='NovaElektik'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Isiklar} alt='Isiklar' />
							<p className={s.Desc}></p>
						</li>

						<li className={s.Item}>
							<img width={320} height={150} src={Elmasan} alt='Elmasan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Garanti} alt='Garanti' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Gencler} alt='Gencler' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Gocmenler} alt='Gocmenler' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Tekkeli} alt='Tekkeli' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Tugsan} alt='Tugsan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Teksan} alt='Teksan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Tunas} alt='Tunas' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Omkatas} alt='Omkatas' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Ozemek} alt='Ozemek' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Perge} alt='Perge' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Maret} alt='Maret' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Metaksan} alt='Metaksan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Merva} alt='Merva' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Namet} alt='Namet' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={NadirEt} alt='NadirEt' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Itimat} alt='Itimat' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={RNV} alt='RNV' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Radsan} alt='Radsan' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Ramcelic} alt='Ramcelic' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img
								width={320}
								height={150}
								src={SismanYumurta}
								alt='SismanYumurta'
							/>
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={SevgiCam} alt='SevgiCam' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Setas} alt='Setas' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={SimiTeks} alt='SimiTeks' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Soprano} alt='Soprano' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Senyayla} alt='Senyayla' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Silivri} alt='Silivri' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={SME} alt='SME' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Sanat} alt='Sanat' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={SahTavuk} alt='SahTavuk' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img width={320} height={150} src={Yasmin} alt='Yasmin' />
							<p className={s.Desc}></p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}
